import React from "react";
import {Button, Form, Input, notification} from "antd";
import {applyGeneralCampaignForm} from "../../util/APIUtils";
import {showAxiosError} from "../../util/Helpers";

function CampaignForm(props) {

    function onFinish(values) {
        values.campaignId = props.campaignId;
        applyGeneralCampaignForm(JSON.stringify(values)).then((response) => {
            notification.success({
                message: "Başarılı",
                description: "Başarılı bir şekilde kayıt oldunuz",
            })
        }).catch((error) => {
            showAxiosError(error.response)
        })
    }

    return (
        <Form onFinish={onFinish} layout="vertical">
            <Form.Item
                label="Adınız"
                name="name"
                rules={[
                    {
                        required: true,
                        message: "Lütfen Adınızı Giriniz.",
                    },
                ]}
            >
                <Input name="name" size="large"/>
            </Form.Item>
            <Form.Item
                label="Soyadınız"
                name="surname"
                rules={[
                    {
                        required: true,
                        message: "Lütfen Soyadınızı Giriniz.",
                    },
                ]}
            >
                <Input name="surname" size="large"/>
            </Form.Item>
            <Form.Item
                label="Telefon Numaranız (GSM)"
                name="phoneNumber"
                rules={[
                    {
                        min: 10,
                        max: 10,
                        required: true,
                        message: "Lütfen Telefon Numaranızı Giriniz. (5XXXXXXXXX)",
                    },
                ]}
            >
                <Input type="number" name="phoneNumber" size="large"/>
            </Form.Item>
            <Form.Item
                label="E-Posta Adresiniz"
                name="email"
                rules={[
                    {
                        type: "email",
                        required: true,
                        message: "Lütfen E-Posta Adresinizi Giriniz.",
                    },
                ]}
            >
                <Input name="email" size="large"/>
            </Form.Item>
            <Form.Item>
                <Button type="primary" htmlType="submit" size="large">
                    Başvur
                </Button>
            </Form.Item>
        </Form>
    );
}

export default CampaignForm;



// WEBPACK FOOTER //
// ./src/component/CampaignForm/index.js